<template lang="pug">
  v-container
    .d-flex.align-center.justify-center.px-6(style="height: 100vh")
      .text-center
        v-icon.mb-2(size="35" color="neutral400") mdi-alert-circle-outline
        .text-xl.font-semibold.mb-2 No subscription found
        .text-sm You are not subscribed to {{ plan }} plan
        .text-sm Please contact admin to subscribe
</template>

<script>
export default {
  props: {
    plan: {
      type: String,
      default: 'marketing'
    },
  },
}
</script>

<style scoped>

</style>